import { ILifeRule } from "./ILifeRule";

export class LiveCellWithMoreThanThreeNeighborsRule implements ILifeRule {
  canHandle = (isAlive: boolean): boolean => isAlive === true;

  shouldLive(numberOfNeighbors: number): boolean {
    return numberOfNeighbors <= 3;
  }
}
